export default {
  //预习任务
  taskInfo: {
    detail: ''
  },
  taskList: '',
  taskListStudent: '',
  courseList: '',
  planList: '',
  classList: '',
  treeList: '',
  messList: '',
  messAdd: '',
  messDel: '',
  messRead: '',
  taskTestStu: '',
  taskTestList: '',
  editTaskDate: '',
}



// WEBPACK FOOTER //
// ./src/store/yxTask/states.js